import blankLines from './blank-lines';
import commas from './commas';
import comments from './comments';
import controlStatements from './control-statements';
import lineHeight from './line-height';
import namingConventions from './naming-conventions';
import semicolons from './semicolons';
import whitespace from './whitespace';

export default {
  comments,
  lineHeight,
  whitespace,
  blankLines,
  semicolons,
  commas,
  namingConventions,
  controlStatements,
};
